import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import Seo from '../../../../components/Misc/Seo';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_1.jpg';
import projectImage2 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_5.jpg';

import Data_NORCATMineExperience from './Data_NORCATMineExperience';

function Work_NORCATMineExperience() {
    const canonical = 'https://studio.norcat.org/OurWork/norcat-mine-experience';
    const title = 'NORCAT Mine Experience | Studio NORCAT - Driven by experiences that matter.';
    const description = 'The NORCAT Mine Experience is a standalone virtual mine tour that builds foundational awareness of the underground mining lifecycle through guided, scenario-based learning.';

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${projectImage1}`}
                ogImageAlt="Preview of the NORCAT Mine Experience project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${projectImage1}`}
                twitterImageAlt="Preview of the NORCAT Mine Experience project"
            />
            <DetailedHeader
                heading="Discover Mining Through a Virtual Tour"
                client="NORCAT / Internal"
                service="Experiential Learning"
                date="2026"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                images={[
                    {
                        image: projectImage1,
                        alt: 'NORCAT Mine Experience project screenshot 1',
                    },
                    {
                        image: projectImage2,
                        alt: 'NORCAT Mine Experience project screenshot 2',
                    },
                    {
                        image: projectImage3,
                        alt: 'NORCAT Mine Experience project screenshot 3',
                    },
                    {
                        image: projectImage4,
                        alt: 'NORCAT Mine Experience project screenshot 4',
                    },
                    {
                        image: projectImage5,
                        alt: 'NORCAT Mine Experience project screenshot 5',
                    },
                ]}
            />

            {Data_NORCATMineExperience.content}
        </>
    );
}

export default Work_NORCATMineExperience;
